import { create } from 'zustand';

type State = {
    name: string | null;
};

type Actions = {
    setName: (name: string) => void;
    removeName: () => void;
};

const useTableStore = create<State & Actions>((set) => ({
    name: null,
    setName: (name: string) => set({ name }),
    removeName: () => set({ name: null }),
}));

export { useTableStore };
